import { useEffect, useState } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import { getWindow } from '@change-corgi/core/window';

import { useIsVenmoQREnabled, usePaypal } from 'src/app/shared/hooks/payments';
import { isLoaded } from 'src/app/shared/utils/async';

export function useCanUseVenmo(): boolean {
	const paypal = usePaypal();
	const [canUseVenmo, setCanUseVenmo] = useState(false);

	const isVenmoQrEnabled = useIsVenmoQREnabled();

	const {
		userAgent: { isWebview },
	} = useUtilityContext();

	useEffect(() => {
		(async function init() {
			// Venmo mobile workflow does not work in webview. User must use either Safari on iOS or Chrome on Android.
			// isBrowserSupported() is not detecting if app is in webview or not.
			if (!isWebview && isLoaded(paypal) && !canUseVenmo) {
				const venmoInstance = await getWindow().braintree.venmo.create({
					client: paypal.braintreeClientInstance,
					allowDesktop: isVenmoQrEnabled,
					allowNewBrowserTab: false,
				});
				setCanUseVenmo(venmoInstance.isBrowserSupported());
				void venmoInstance.teardown();
			}
		})();
	}, [paypal, canUseVenmo, isVenmoQrEnabled, isWebview]);
	return canUseVenmo;
}
